export default {
  id: 77,
  title: 'Target #77 - Notes',
  url: 'https://cssbattle.dev/play/77',
  colors: ['#191919', '#FE5F55', '#A64942'],
  solution:
    '<a a><a b><a c><style>[a],[b]{box-shadow:70px 0 #fe5f55,140px 0 #a64942,210px 0 #fe5f55}[b],[c]{top:90;background:#fe5f55}[a],[b],[c]{background:#fe5f55}body{background:#191919}a{position:fixed}[a]{top:170;left:55;width:50;height:40;border-radius:100%}[b]{left:95;width:10;height:100}[c]{left:105;width:30;height:10;box-shadow:30px 0 #fe5f55,140px 0 #a64942,210px 0 #fe5f55,210px 20px #fe5f55}</style>',
}
